<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Affiliate Payout Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Loyalty Point System</b> /
      <router-link to="/lps/report/view/affiliate">Reports</router-link> /
      <router-link to="/lps/report/view/affiliate">Affiliate</router-link> /
      <b>Payouts</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <!-- Active -->
              <div class="row">
                <div class="col-12 col-lg-6 col-sm-12">
                  <h4 class="card-title mb-3">
                    <b
                      >Referral Code Payout Report for:
                      {{ referral_details.affiliate.name }} ({{
                        referral_details.account_number
                      }})
                      </b
                    >
                  </h4>
                  <p>The table shows the referral code payout report.</p>
                </div>
              </div>

              <div class="table-responsive">
                <div class="text-right">
                  <input
                    type="button"
                    to="/"
                    class="btn btn-success btn-rounded col-md-1"
                    value="Pay"
                    @click="redirectToPayment()"
                  />
                </div>
              </div>
              <table
                id="payout_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Total Used</th>
                    <th>Invoice</th>
                    <th>Status</th>
                    <th>Payment Vouchers</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ convertMonth(list.month) }}</td>
                    <td>{{ list.year }}</td>
                    <td>{{ parseInt(list.total) }}</td>
                    <td>
                      {{ checkInvoice(list.invoice_url) }}
                    </td>
                    <td>{{ checkCashed(list.cashed) }}</td>
                    <td>
                      {{ list.payment_voucher ? list.payment_voucher : "-" }}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        v-model="payout_ids"
                        :value="list.id"
                        :id="'checkbox_' + list.id"
                        :disabled="list.cashed == 1"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      lists: [],
      payout_ids: [],
      referral_details: {},
      check: "",
    };
  },

  methods: {
    async loadDetails() {
      if (this.checkToken() == false) {
        swal({
          icon: "error",
          text: "You are not authorised",
        });
        return;
      }

      try {
        let id = this.$route.params.id;
        let result = await axios.get(axios.lpsURL + "/payout/affiliate/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        let result_details = await axios.get(axios.lpsURL + "/referral_code/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        this.lists = result.data.payouts;
        this.referral_details = result_details.data;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    convertMonth(int) {
      switch (int) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    checkInvoice(str) {
      if (str == null) {
        return "N/A";
      }
      return "Completed";
    },

    checkCashed(str) {
      if (str == 0) {
        return "Unpaid";
      }
      return "Paid";
    },

    redirectToPayment() {
      if (this.payout_ids.length == 0) {
        swal({
          icon: "error",
          text: "Please select payouts to pay",
        });

        return;
      }
      localStorage.setItem("payout_ids", JSON.stringify(this.payout_ids));
      localStorage.setItem("balance_id", JSON.stringify(this.$route.params.id));
      this.$router.push({ name: "affiliate-payment" });
    },

    viewInvoice(id) {
      if (!this.checkToken()) {
        return;
      }
      axios
        .get(axios.lpsURL + "/payout/download/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
          responseType: "arraybuffer",
        })
        .then((res) => {
          let type = "application/pdf";
          let blob = new Blob([res.data], { type: type }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    },

    redirect(id, month1, year) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let month = months.indexOf(month1) + 1;

      return "/report/view/" + id + "/" + month1 + "/" + year;
    },

    destroyDatatable() {
      $("#payout_tbl").DataTable().destroy();
    },

    createDatatable() {
      $("#payout_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            filename: `Referral Code (${this.referral_details.account_number}) Payout Report`,
            title: `Referral Code (${this.referral_details.account_number}) Payout Report`,

          },
          {
            extend: "pdfHtml5",
            filename: `Referral Code (${this.referral_details.account_number}) Payout Report`,
            title: `Referral Code (${this.referral_details.account_number}) Payout Report`,
          }
        ]
      });
    },
  },

  async created() {
    await this.loadDetails();
    this.createDatatable();
  },
};
</script>
